import { useEffect } from 'react'
import { SurveyEngine_Models_BaseResponse, SurveyEngine_Models_PlayValueResponse } from '../../../api'
import { Label } from '@progress/kendo-react-labels'
import parse from 'html-react-parser'
interface playValueprops {
 id: number
 message: string
 callback: (response: SurveyEngine_Models_BaseResponse) => void
}
export const PlayValue = (props:playValueprops) =>{
  useEffect(() => {
    let response: SurveyEngine_Models_PlayValueResponse = {
      commandType: "PlayValue",
      commandIndex: props.id,
    }
    props.callback(response);
  });
 
  return (
    <>
      <div className="theme-playvalue w-full" data-testid="playvalue" autoFocus>
        <Label id={`PlayValue_${props.id}`} aria-live="polite" className="py-10 text-xl font-semibold">
          {parse(props.message.replace(/""/g,'"'))}
        </Label>
      </div>
    </>
  )
}
